import React, { useEffect, useState, useCallback } from 'react';
import NoticeTable from './NoticesTable';
import NoticeTableTopBar from './NoticeTableTopBar';
import { fetchAllNotices } from '../NoticesAPI';

const NoticeContainer = () => {
    const [notices, setNotices] = useState([]);
    const [error, setError] = useState('');
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [refreshFlag, setRefreshFlag] = useState(false);
    const [filterOptions, setFilterOptions] = useState({});
    const [fetchTrigger, setFetchTrigger] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);

    const refetchNoticeData = useCallback(async (options = {}) => {
        setDataLoaded(false);
        try {
            const data = await fetchAllNotices(pageNumber, 10, filterOptions);
            setNotices(data.notices);
            setTotalPages(data.totalPages);
            setError('');
            setDataLoaded(true);
        } catch (error) {
            console.error('Error fetching all notices:', error.message);
            setError('Failed to fetch notices data.');
            setNotices([]);
            setTotalPages(0);
        }
    }, [filterOptions, pageNumber]);

    useEffect(() => {
        refetchNoticeData();
    }, [pageNumber, refreshFlag, refetchNoticeData, totalPages, fetchTrigger, filterOptions]);

    return (
        <>
            <NoticeTableTopBar
                refetchNoticeData={refetchNoticeData}
                setPageNumber={setPageNumber}
                setFilterOptions={setFilterOptions}
                setFetchTrigger={setFetchTrigger}

            />
            <NoticeTable
                notices={notices}
                setNotices={setNotices}
                setRefreshFlag={setRefreshFlag}
                refetchNoticeData={refetchNoticeData}
                error={error}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
                totalPages={totalPages}
                setTotalPages={setTotalPages}
                filterOptions={filterOptions}
                dataLoaded={dataLoaded}
            />
        </>
    );
};

export default NoticeContainer;
